import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * AuthTokenValidation component
 * 
 * Displays a loading spinner while the auth token is being validated.
 * This component is rendered to the DOM before the React app mounts.
 */
export function AuthTokenValidation() {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
				width: '100vw',
				backgroundColor: 'background.default',
				gap: 2,
			}}
		>
			<CircularProgress size={48} />
			<Typography variant="h6" color="text.secondary">
				Validating authentication...
			</Typography>
		</Box>
	);
}
